/**
 * Catalogs Page
 * Catalog management interface (placeholder)
 */

export function CatalogsPage() {
  return (
    <div className="flex-1 p-8 overflow-auto bg-zinc-950">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-4">Catalogs</h1>
        <p className="text-gray-400">
          Catalog management interface coming soon...
        </p>
      </div>
    </div>
  );
}
